import React from 'react';

const VargaChartTable = ({ vargaData, chartName }) => {
  if (!vargaData || typeof vargaData !== 'object') {
    return <div className="text-white/50 text-center py-4">No data available for {chartName}</div>;
  }

  const planets = Object.keys(vargaData).filter(key => key !== '_aspects_rasi' && key !== '_crossmap_D1_to_Dx' && key !== 'Asc');
  
  return (
    <div className="mb-6">
      <h4 className="text-white text-md font-medium mb-3">{chartName}</h4>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="bg-purple-900/30 border-b border-purple-700/50">
              <th className="text-left p-2 text-purple-300">Planet</th>
              <th className="text-left p-2 text-purple-300">Sign</th>
              <th className="text-center p-2 text-purple-300">House</th>
              <th className="text-center p-2 text-purple-300">Vargottama</th>
            </tr>
          </thead>
          <tbody>
            {/* Ascendant row */}
            {vargaData.Asc && (
              <tr className="border-b border-white/10 bg-yellow-500/5">
                <td className="p-2 text-yellow-400 font-medium">Ascendant</td>
                <td className="p-2 text-yellow-300">{vargaData.Asc.sign}</td>
                <td className="p-2 text-center text-yellow-300">{vargaData.Asc.house}</td>
                <td className="p-2 text-center">
                  <span className={`px-2 py-0.5 rounded text-xs ${vargaData.Asc.vargottama ? 'bg-green-500/20 text-green-300' : 'bg-gray-500/20 text-gray-400'}`}>
                    {vargaData.Asc.vargottama ? 'Yes' : 'No'}
                  </span>
                </td>
              </tr>
            )}
            {/* Planet rows */}
            {planets.map((planet, idx) => (
              <tr key={idx} className="border-b border-white/10 hover:bg-white/5 transition-colors">
                <td className="p-2 text-white font-medium">{planet}</td>
                <td className="p-2 text-cyan-300">{vargaData[planet]?.sign || 'N/A'}</td>
                <td className="p-2 text-center text-purple-300">{vargaData[planet]?.house || 'N/A'}</td>
                <td className="p-2 text-center">
                  <span className={`px-2 py-0.5 rounded text-xs ${vargaData[planet]?.vargottama ? 'bg-green-500/20 text-green-300' : 'bg-gray-500/20 text-gray-400'}`}>
                    {vargaData[planet]?.vargottama ? 'Yes' : 'No'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VargaChartTable;
